import { render, staticRenderFns } from "./text-3-rows.vue?vue&type=template&id=4f6ccd4c&scoped=true&"
import script from "./text-3-rows.vue?vue&type=script&lang=js&"
export * from "./text-3-rows.vue?vue&type=script&lang=js&"
import style0 from "./text-3-rows.vue?vue&type=style&index=0&id=4f6ccd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ccd4c",
  null
  
)

export default component.exports